<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Sales Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "status",
          sortable: true,
          label: "STATUS",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "customer",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "user",
          sortable: true,
          label: "USER",
        },
        {
          key: "addedon",
          sortable: true,
          label: "DATE",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        customer: "",
        branch_id: 0,
        receipt: "",
        app: "",
        status:""
      },
      editAmtData: {
        id: "",
        total: "",
        paid: "",
      },
      submitData: {
        id: "",
        filterdata: {}
      },
      deleteData: {
        id: "",
        reason:"",
        filterdata:{}
      },
      editData: {
        id: "",
        reason:""
      },
      invoice:{
        id:''
      },
      amountError: "",
      totals: {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
        totalBalance: 0,
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("saledetails", ["SaveStatus", "Sales", "filterStatus"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),
    ...mapGetters("setting", ["GeneralSettings", "ReceiptSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Sales ? this.Sales.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Sales ? this.Sales.length : 1;
  },
  updated() {},
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    Sales(newValue) {
      if (newValue) {
        this.SalesData();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchSales: "saledetails/fetchSales",
      EditPaid: "saledetails/editAmtPaidMode",
      EditSale: "saledetails/editSale",
      DeleteSale: "saledetails/deleteSale",
      FetchCustomers: "customers/fetchCustomers",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      SubmitSale: "saledetails/submitSale",
      GenerateNewInvoice:"invoices/generateInvoice"
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    SalesData() {
      if (this.Sales) {
        let total_amount = 0;
        let total_paid = 0;
        let total_discount = 0;
        this.Sales.forEach((item) => {
          total_amount = total_amount + parseInt(item.totalAmt);
          total_paid = total_paid + parseInt(item.totalPaid);
          total_discount = total_discount + parseInt(item.discount);

          this.totals.totalBalance =
            this.totals.totalAmount -
            (this.totals.totalPaid + this.totals.totalDiscount);
        });
        this.totals.totalPaid = total_paid;
        this.totals.totalAmount = total_amount;
        this.totals.totalDiscount = total_discount;
        this.totals.totalBalance = total_amount - (total_paid + total_discount);
      }
    },

    resetModal() {
      this.editAmtData.id = "";
      this.editAmtData.total = "";
      this.editAmtData.paid = "";
    },
    resetError() {
      this.amountError = "";
    },
    resetDelete() {
      this.deleteData.id = "";
      this.deleteData.reason = "";
    },
    resetEdit() {
      this.editData.id = "";
      this.editData.reason = "";
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    showSubmitModal(data) {
      this.submitData.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
    },
    addCommas() {
      this.editAmtData.paid = this.thousandSeperator(this.editAmtData.paid);
    },
    ShowEdit(data) {
      this.editAmtData.id = data.id;
      this.editAmtData.total = data.totalAmt;
      this.editAmtData.paid = this.thousandSeperator(data.totalPaid);
    },

    showInvoiceModal(data) {
      this.invoice.id = data.item.id;
    },

    editAmt(modalId) {
      this.modal_id = modalId;
      if (this.editAmtData.paid == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      this.EditPaid(this.editAmtData);
    },

    editSale(modalId) {
      this.modal_id = modalId;
      this.EditSale(this.editData);
    },

    submitSale(modalId) {
      this.submitData.filterdata = this.data;
      this.modal_id = modalId;
      this.SubmitSale(this.submitData);
    },

    deleteSale(modalId) {
      this.deleteData.filterdata = this.data;
      this.modal_id = modalId;
      this.DeleteSale(this.deleteData);
    },

    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    
    filterReport() {
      this.FetchSales(this.data);
    },

    Receipt_print(Id){
      if(this.ReceiptSettings.receipt_type == 1){
          window.open(
            `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(Id)}`
          );
      }else if(this.ReceiptSettings.receipt_type == 2){
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv2.php?id=${btoa(Id)}`
        );
      }else if(this.ReceiptSettings.receipt_type == 3){
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv3.php?id=${btoa(Id)}`
        );
      }else if(this.ReceiptSettings.receipt_type == 4){
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv4.php?id=${btoa(Id)}`
        );
      }else if(this.ReceiptSettings.receipt_type == 5){
          window.open(
            `https://${window.location.host}/receipts/deliverynote.php?id=${btoa(Id)}`
          );
      }else{
        window.open(
          `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(Id)}`
        );
      }
    },

    GenerateInvoice(modal){
      this.GenerateNewInvoice(this.invoice.id);  
      this.closeModal(modal);   
    },

    resetGenerate(){
      this.invoice.id = "";
    },
  },
  created() {
    this.FetchGeneralSettings();
    this.FetchCustomers();
    this.FetchBranches();
    this.FetchSales(this.data);
    this.fetchReceiptSettings();
  },
};
</script>

<template>
  <Layout>
    <h4 class="text-center text-primary">{{ business }} - {{ branch }}</h4>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-3"></div>
              <div class="col-md-6">
                <h3 class="card-title mb-2 text-center" v-html="title"></h3>
              </div>
              <div class="col-md-3">
                <label>FILTER BY STATUS</label>
                <select v-model="data.status" @change="filterReport()" class="form-control">
                  <option value=''>All statuses</option>
                  <option value="1">Synchronized</option>
                  <option value="2">Unsynchronized</option>
                </select>
              </div>
            </div>
            <div class="row" v-if="branchid == 0">              
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="data.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>                            
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label>CUSTOMERS</label>

                <model-list-select
                  :list="Customers ? Customers : []"
                  v-model="data.customer"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Customer"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>RECEIPT NO.</label>

                <input
                  class="form-control"
                  v-model="data.receipt"
                  placeholder="Enter Receip No"
                  @keyup.enter="filterReport()"
                />
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-md-4">
                <router-link :to="'/advanced_reports/salesanalysis_report'">
                  <b-button variant="info">Receipts & Returns</b-button>
                </router-link>
              </div>
              <!-- Search -->
              <div class="col-md-4">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Sales ? Sales : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>
                <template #cell(amt_paid)="data">
                  <span
                    class="text-warning"
                    v-b-modal.expired-modal
                    @click="ShowEdit(data.item)"
                    v-if="data.item.numpaid < 2"
                  >
                    {{ thousandSeperator(data.item.totalPaid) }}
                  </span>
                  <span v-else>
                    {{ thousandSeperator(data.item.totalPaid) }}
                  </span>
                </template>
                <template #cell(status)="data">
                  <button
                    class="btn btn-info btn-sm"
                    v-b-modal.sale-submit-modal
                    @click="showSubmitModal(data)"
                    v-if="MyUserPerm.edit_sales == 1 && !data.item.fdn"
                  >
                    Synchronize
                  </button>
                  <button
                    class="btn btn-sm"
                    disabled
                    v-if="MyUserPerm.edit_sales == 1 && data.item.fdn"
                  >
                    <h6>Synchronized</h6>
                  </button>                  
                </template>
                <template #cell(discount_field)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(actions)="data">
                  <div>
                    <b-dropdown
                      text="More Actions..."
                      size="sm"
                      class="btn-primary"
                    >
                      <b-dropdown-item
                        v-if="MyUserPerm.delete_sales == 1"
                        v-b-modal.delete-purchase-modal
                        @click="showDeleteModal(data)"
                      >
                        <i class="fa fa-trash text-danger"></i>
                        <span class="text-danger">Delete</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="MyUserPerm.edit_sales == 1"
                        v-b-modal.edit-purchase-modal
                        @click="showEditModal(data)"
                        ><i class="fa fa-edit text-primary"></i>
                        <span class="text-primary">Edit</span>
                      </b-dropdown-item>
                      <b-dropdown-item variant="info" @click="Receipt_print(data.item.id)"><i class="fa fa-download"></i>Reprint</b-dropdown-item>
                      <b-dropdown-item
                        v-if="data.item.totalAmt>data.item.totalPaid"
                        v-b-modal.generate-invoice-modal
                        @click="showInvoiceModal(data)"
                        ><i class="fa fa-file-invoice text-success"></i> <span class="text-success"> New Invoice</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
                <template #cell(details)="data">
                  <table class="table">
                    <tbody>
                      <tr
                        v-for="(det, d) in data.item.items"
                        :key="d"
                        width="100%"
                      >
                        <td>{{ det.product }}</td>
                        <td>{{ det.qty }}{{ det.usymbol }}</td>
                        <td>
                          {{ det.SPrice ? thousandSeperator(det.SPrice) : 0 }}
                        </td>
                        <td>
                          {{
                            det.SPrice
                              ? thousandSeperator(det.SPrice * det.qty)
                              : 0
                          }}
                        </td>
                        <!-- <td>{{ det.batch }}</td>
                      <td>{{ det.expiry }}</td> -->
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-3">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Paid:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalPaid)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Discount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalDiscount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Balance:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalBalance)
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <Loader v-if="!Sales" />
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal mark as expired starts -->
    <b-modal id="expired-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">
          Edit Amount Paid For a Sale of
          {{ thousandSeperator(editAmtData.total) }}
        </h4></template
      >
      <label>Amount Paid</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="editAmtData.paid"
          placeholder="Quantity removed"
          @input="resetError(), addCommas()"
        />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('expired-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-warning"
          disabled
        >
          <i class="fa fa-minus"></i> Confirm
          <b-spinner            
            variant="light"
            small
            label="Submiting"
          ></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-warning"
          @click="editAmt('expired-modal')"
        >
          <i class="fa fa-minus"></i> Confirm
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal
      header-bg-variant="warning"
      header-text-variant="light"
      body-text-variant="warning"
      footer-bg-variant="warning"
      footer-text-variant="warning"
      id="edit-purchase-modal"
      hide-footer
      @hidden="resetEdit"
    >
      <template #modal-title> Edit This Sale</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            Do you want to return and edit this Sale? Click Proceed Button to
            Return Sale for Editing.
          </h5>
        </div>
      </div>
      <div class="form-group mb-3">
          <label>Reason</label>
          <div class="input-group">
          <textarea
              type="text"
              placeholder="Enter reason"
              class="form-control" 
              v-model="editData.reason"
          ></textarea>
          </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('edit-purchase-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-edit"></i> Proceed
          <b-spinner            
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="editSale('edit-purchase-modal')"
        >
          <i class="fa fa-edit"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-purchase-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete This Sale</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            Do you want to delete this Sale? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="form-group mb-3">
          <label>Reason</label>
          <div class="input-group">
          <textarea
              type="text"
              placeholder="Enter reason"
              class="form-control" 
              v-model="deleteData.reason"
          ></textarea>
          </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-purchase-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-danger"
          disabled
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner            
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-danger"
          @click="deleteSale('delete-purchase-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- resynchronise mode starts -->
    <b-modal
      header-bg-variant="info"
      header-text-variant="light"
      body-text-variant="info"
      footer-bg-variant="info"
      footer-text-variant="info"
      id="sale-submit-modal"
      hide-footer
      @hidden="resetEdit"
    >
      <template #modal-title> Resubmit This Sale</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            You are submitting this sale to URA? Click Proceed Button to Submit
            the Sale.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('sale-submit-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-check"></i> Proceed
          <b-spinner            
            variant="light"
            small
            label="Submitting"
          ></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="submitSale('sale-submit-modal')"
        >
          <i class="fa fa-check"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- resynchronise mode ends -->

    <!-- Invoice modal starts -->
    <b-modal
              header-bg-variant="success"
              header-text-variant="light"
              body-text-variant="success"
              footer-bg-variant="success"
              footer-text-variant="success"
              id="generate-invoice-modal"
              hide-footer
              @hidden="resetGenerate"
            >
              <template #modal-title> Generate invoice</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Click Proceed Button to generate an invoice for this sale.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('generate-invoice-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  type="button"
                  class="btn btn-success"
                  disabled
                >
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner                    
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-success"
                  @click="GenerateInvoice('generate-invoice-modal')"
                >
                  <i class="fa fa-edit"></i> Proceed
                </button>
              </div>
    </b-modal>
    <!-- Invoice modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
